import { useDispatch } from 'react-redux'

const DEFAULT_OPTIONS = {
  time: 7000, showClose: false, showUndo: false, closeSnackbar: false, undoAction: () => { }
}

export function useSnackbar() {
  const dispatch = useDispatch()
  const setSnackbar = (message = "", options = DEFAULT_OPTIONS) => {
    dispatch({ type: 'CHANGE_SNACKBAR', payload: { message, options: { ...DEFAULT_OPTIONS, ...options } } })
  }
  return setSnackbar
}